import InfoBox from "react-google-maps/lib/components/addons/InfoBox";

class InfoBoxCustom extends InfoBox {
  componentDidUpdate(prevProps, prevState, snapshot) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    const ua = (window && window.navigator && window.navigator.userAgent) || null;
    const msie = (ua && ua.indexOf("MSIE ")) || null;
    if ((msie && msie > 0) || (ua && ua.match(/Trident.*rv\:11\./))) {
      this.state.infoBox.open(this.props.mapHolderRef.getMap());
    }
  }
  componentDidMount() {
    super.componentDidMount();
    const ua = (window && window.navigator && window.navigator.userAgent) || null;
    const msie = (ua && ua.indexOf("MSIE ")) || null;
    if ((msie && msie > 0) || (ua && ua.match(/Trident.*rv\:11\./))) {
      this.state.infoBox.open(this.props.mapHolderRef.getMap());
    }
  }
}

export default InfoBoxCustom;
